import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useRoutes } from '@providers/TenantProvider';
import { LoadingSpinner } from '@components/ui/LoadingSpinner';

// Lazy load pages for code splitting
const BeveragesHomePage = lazy(() => import('@features/beverages/pages/BeveragesHomePage'));
const ObjectDetailsPage = lazy(() => import('@features/beverages/pages/ObjectDetailsPage'));
const CipAnalyticsPage = lazy(() => import('@features/cip-analytics/pages/CipAnalyticsPage'));
const SignedOutPage = lazy(() => import('@features/auth/pages/SignedOutPage'));
const NotFoundPage = lazy(() => import('@features/common/pages/NotFoundPage'));

/**
 * Page loading fallback component
 */
function PageLoader() {
  return (
    <div className="flex h-[50vh] items-center justify-center">
      <LoadingSpinner size="lg" />
    </div>
  );
}

/**
 * App routes component
 * Routes are filtered based on tenant configuration
 */
export function AppRoutes() {
  const routes = useRoutes();

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Redirect root to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Dashboard - always available */}
        {routes.dashboard && (
          <Route path="/dashboard" element={<BeveragesHomePage />} />
        )}

        {/* Object details */}
        <Route path="/object/:objectId" element={<ObjectDetailsPage />} />

        {/* Root Cause Analysis */}
        {routes.cipAnalytics && (
          <Route path="/rca" element={<CipAnalyticsPage />} />
        )}

        {/* Auth routes */}
        <Route path="/signed-out" element={<SignedOutPage />} />

        {/* 404 - catch all */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
